import { Component, Input } from '@angular/core';
import { ICellConfig } from '../base-cell/base-cell.component';
import { BaseCellComponent } from '../base-cell/base-cell.component';

export interface IListItemData {
  text: string;
}

export interface IDSListCellConfig extends ICellConfig {
  items: IListItemData[];
}

@Component({
  selector: 'table-cell-ds-list',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  template: `
    <ul #ref>
      <li *ngFor="let item of config.items; let isLast = last" [ngClass]="{ 'mb-3': !isLast }">{{ item.text }}</li>
    </ul>
  `,
})
export class DsListCellComponent extends BaseCellComponent {
  @Input() public config: IDSListCellConfig;
}
